import React, { useEffect } from 'react';
import { PencilRuler } from 'lucide-react';

const About = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const architects = [
        "Sandeep Joshi",
        "Abhishek Shrivastav",
        "Chitresh Koul",
        "Anshul Sharma",
        "Bhagwan Lal Purohit"
    ];

    return (
        <div className="bg-white min-h-screen">
            {/* Hero / Intro */}
            <div className="bg-gray-900 py-20 text-white text-center">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">About Us</h1>
                    <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                        15 Years of Excellence in Construction. Building legacy through trust, quality, and innovation.
                    </p>
                </div>
            </div>

            {/* Leadership Section */}
            <section className="py-16 container mx-auto px-4">
                <div className="text-center mb-16">
                    <h2 className="text-3xl font-bold text-gray-800 mb-4">Our Leadership</h2>
                    <div className="w-20 h-1 bg-primary mx-auto"></div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto">
                    {/* Founder */}
                    <div className="bg-gray-50 p-8 rounded-xl shadow-md text-center hover:shadow-xl transition-shadow duration-300">
                        <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white shadow-lg">
                            <img
                                src="/assets/photos/team/ashok_joshi.png"
                                alt="Mr. Ashok Joshi"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">Mr. Ashok Joshi</h3>
                        <p className="text-primary font-semibold uppercase tracking-wider mt-2">Founder</p>
                        <p className="text-gray-600 mt-4 leading-relaxed">
                            With a vision to redefine the skyline, Mr. Ashok Joshi laid the foundation of our company 15 years ago. His commitment to quality and integrity remains our guiding light.
                        </p>
                    </div>

                    {/* Promoter */}
                    <div className="bg-gray-50 p-8 rounded-xl shadow-md text-center hover:shadow-xl transition-shadow duration-300">
                        <div className="w-48 h-48 mx-auto mb-6 rounded-full overflow-hidden border-4 border-white shadow-lg">
                            <img
                                src="/assets/photos/team/piyush_joshi.png"
                                alt="Mr. Piyush Joshi"
                                className="w-full h-full object-cover"
                            />
                        </div>
                        <h3 className="text-2xl font-bold text-gray-800">Mr. Piyush Joshi</h3>
                        <p className="text-primary font-semibold uppercase tracking-wider mt-2">Promoter</p>
                        <p className="text-gray-600 mt-4 leading-relaxed">
                            Driving the company forward with modern techniques and a customer-centric approach. Piyush ensures that every project meets the highest standards of excellence.
                        </p>
                    </div>
                </div>
            </section>

            {/* Legacy & Values */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                    <div>
                        <img
                            src="/assets/elevations.png"
                            alt="Construction Site"
                            className="rounded-lg shadow-xl w-full h-auto object-cover"
                        />
                    </div>
                    <div>
                        <h2 className="text-3xl font-bold text-gray-800 mb-6">Building Dreams into Reality</h2>
                        <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                            For over a decade and a half, Joshi Construction has been a name synonymous with trust. We don't just build structures; we build relationships. Our journey is marked by over 100 successful projects and countless happy families.
                        </p>
                        <ul className="space-y-4">
                            <li className="flex items-center text-gray-700">
                                <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                                Uncompromised Quality
                            </li>
                            <li className="flex items-center text-gray-700">
                                <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                                Timely Delivery
                            </li>
                            <li className="flex items-center text-gray-700">
                                <div className="w-2 h-2 bg-primary rounded-full mr-3"></div>
                                Transparent Dealings
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Trusted Architects & Consultants */}
            <section className="py-16 container mx-auto px-4 text-center">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">Architects / Consultants</h2>
                <div className="w-20 h-1 bg-primary mx-auto mb-12"></div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
                    {architects.map((name, index) => (
                        <div key={index} className="bg-white border border-gray-100 p-6 rounded-lg shadow-sm hover:border-primary transition-colors duration-300 group">
                            <PencilRuler size={32} className="text-gray-400 mx-auto mb-4 group-hover:text-primary transition-colors" />
                            <h4 className="text-lg font-semibold text-gray-800">{name}</h4>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default About;
